import { DEFAULT_BUILD_OPTIONS } from '@speechki-frontend/core/editor/components/BooksBuilds/utils';
import {
    fetchOrderBuilds,
    createOrderBuilds,
    checkOrderBuildsQueue,
    fetchOrderNoteBuilds,
    createOrderNoteBuilds,
    checkOrderNoteBuildsQueue,
} from '../../api/orders';

export const BUILDERS = [
    {
        name: 'Audiobook',
        api: {
            fetch() {
                const { id } = this.route.params;
                return fetchOrderBuilds(id);
            },
            building(configs) {
                const data = {
                    build_configs: configs.map((config) => {
                        const {
                            build_types = [],
                            speed,
                            without_title,
                            without_author,
                            without_preview,
                        } = config;

                        return {
                            ...DEFAULT_BUILD_OPTIONS,
                            provider: config.providers,
                            build_types,
                            speed,
                            without_title,
                            without_author,
                            without_preview,
                        };
                    }),
                };
                return createOrderBuilds(this.route.params.id, data);
            },
            checking() {
                return checkOrderBuildsQueue(this.route.params.id);
            },
        },
    },
    {
        name: 'Subtitles',
        api: {
            fetch() {
                const { id } = this.route.params;
                const params = { build_type: 'subtitles' };
                return fetchOrderNoteBuilds(id, params);
            },
            building() {
                const { id } = this.route.params;
                const params = { build_type: 'subtitles' };
                return createOrderNoteBuilds(id, params);
            },
            checking() {
                const { id } = this.route.params;
                const params = { build_type: 'subtitles' };
                return checkOrderNoteBuildsQueue(id, params);
            },
        },
    },
    {
        name: 'Metadata',
        api: {
            building(configs) {
                const { providers = [] } = configs.shift();
                const data = {
                    build_configs: providers.map((provider) => ({
                        ...DEFAULT_BUILD_OPTIONS,
                        build_types: ['meta_info'],
                        provider,
                    })),
                };
                return createOrderBuilds(this.route.params.id, data);
            },
            checking() {
                return checkOrderBuildsQueue(this.route.params.id);
            },
        },
    },
];
